<template>
    <dropdown tag="li" class="nav-item language-switcher" v-if="!hideSwitcher">
        <dropdown-toggle tag="a" navLink color="white" slot="toggle" waves-fixed><img :src="icons[currentLocale]" class="country-icon as-toggle"/> {{currentLocaleName}}</dropdown-toggle>
        <dropdown-menu>
            <router-link v-for="locale in locales" :key="locale.code" :to="`/${locale.code}/${currentRoute}`" class="dropdown-item">
                <img :src="icons[locale.code]" class="country-icon" />
                <span class="locale-name">{{locale.name}}</span>
            </router-link>
        </dropdown-menu>
    </dropdown>
</template>

<script>
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'mdbvue';
import enIcon from 'svg-country-flags/svg/gb.svg'
import frIcon from 'svg-country-flags/svg/fr.svg'
import esIcon from 'svg-country-flags/svg/es.svg'
import plIcon from 'svg-country-flags/svg/pl.svg'
import itIcon from 'svg-country-flags/svg/it.svg'
import deIcon from 'svg-country-flags/svg/de.svg'
import nlIcon from 'svg-country-flags/svg/nl.svg'
import caIcon from 'svg-country-flags/svg/ca.svg'
import {isTalentApp} from '../services/User.service'

import { locales } from '../plugins/i18n'

export default {
    data() {
        return {
            icons: {
                en: enIcon,
                fr: frIcon,
                es: esIcon,
                pl: plIcon,
                it: itIcon,
                de: deIcon,
                nl: nlIcon,
                qc: caIcon,
            },
            locales,
            currentLocaleName: '',
            hideSwitcher: (isTalentApp() ? true : false)
        }
    },
    components: {
        Dropdown, DropdownItem, DropdownMenu, DropdownToggle
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
        currentRoute(){
            let length = this.$route.path.split('/').length - 1
            if(length <= 1){
                return this.$route.path.split('/').slice(-2)[0]
            }else{
                return this.$route.path.split('/').slice(-1)[0]
            }
        }
    },
    methods: {
        getCurrentLocaleName(){
            this.locales.map(loc => {
                if(this.currentLocale == loc.code){
                    this.currentLocaleName = loc.name
                }
            });
        }
    },
    mounted(){
        this.getCurrentLocaleName();
    }
}
</script>

<style scoped>
.country-icon {
width: 20px;
height: auto;
display: inline-block;
vertical-align: baseline;
border: 1px solid #dee2e6;
box-shadow: 0px 1px 3px rgba(24, 29, 38, 0.1);
}
.country-icon.as-toggle {
margin-top: 5px;
}
.locale-name {
display: inline-block;
vertical-align: baseline;
}
.language-switcher .router-link-active {
display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSwitcher.vue